import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthContextService } from '@core/services/auth-context.service';

export const rootRedirectGuard: CanActivateFn = async () => {
  const ctx = inject(AuthContextService);
  const router = inject(Router);

  const logged = await ctx.syncSession();
  const mode = ctx.getMode();

  if (mode === 'upload-files') {
    return router.createUrlTree([logged ? '/upload' : '/upload-files']);
  }

  return router.createUrlTree([logged ? '/home' : '/login']);
};
